export default __webpack_public_path__ + "static/media/clean-home-hero.5b3f0451.png";